'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _media = require('./media.component');

var _media2 = _interopRequireDefault(_media);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mediaModule = _angular2.default.module('app.containers.media', [_angularUiRouter2.default]).config(function ($stateProvider) {
  "ngInject";

  $stateProvider.state('media', {
    url: '/media',
    template: '<media></media>'
  });
}).component('media', _media2.default);

exports.default = mediaModule;


/** WEBPACK FOOTER **
 ** ./client/app/containers/media/media.js
 **/